import { OnLoginResponse } from "../Login";
import { NewPasswordForm } from "./NewPasswordForm";

interface IProps {
  onLoginResponse: OnLoginResponse;
}

export const ActivateAgentForm = ({ onLoginResponse }: IProps) => {
  return <NewPasswordForm onLoginResponse={onLoginResponse} />;
};
